import React, { Fragment, useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Button, Col, Row } from 'reactstrap';
import ModalUI from '../../../../shared/components/Modal';
import DataReactTableTypesExpenses from './DataReactTableTypesExpenses';
import Spinner from 'react-bootstrap/Spinner';


const TypeExpensesForm = ({ setTypeExpense }) => {
    const [nameExpense, setNameExpense] = useState('');
    const [openAlert, setOpenAlert] = useState(false);
    const [loadTable, setLoadTable] = useState(true);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });
    const [errors, setErrors] = useState({});
    const [listTypesExpenses, setListTypesExpenses] = useState([]);
    const [editTypeExpense, setEditTypeExpense] = useState(false);
    const [idTypeExpense, setIdTypeExpense] = useState('');

    useEffect(() => {
        getTypesExpenses();
    }, [])

    const getTypesExpenses = async () => {
        setLoadTable(true);

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'gastos-tipo/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                console.log("TYPESEXPENSES", data)
                setLoadTable(false);
                setListTypesExpenses(data);
                setTypeExpense(data);
            })
            .catch((error) => {
                console.log(error)
            })
    };

    const validateForm = (values) => {
        const errors = {};
        if (!values.nombre) {
            errors.nombre = "Campo obligatorio";
        }

        console.log("ERRORSFORM", errors);
        return errors;
    }

    const reactTableDataTypesExpenses = {
        tableHeaderData: [{
            Header: 'NOMBRE',
            accessor: 'nombre',
            disableGlobalFilter: true,
            width: 65
        },
        ],
        tableRowsData: listTypesExpenses
    };
    const saveTypeExpense = async () => {
        let dataSend = {
            nombre: nameExpense
        };

        let errors = validateForm(dataSend);
        setErrors(errors);

        console.log("DATASEND", dataSend, "ERRORSINSIDE", errors);


        if (Object.entries(errors).length === 0) {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'gastos-tipo/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then((response) => {
                    console.log("RESAPONSEFROMSERVER", response)
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error(response.text());
                    }
                })
                .then((data) => {
                    console.log("DATARESPONSE", data);
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Guardado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                    setNameExpense('');
                    getTypesExpenses();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }

    const updateTypeExpense = async (idToUpdate) => {

        let dataSend = {
            id_tipo_gasto: parseInt(idToUpdate),
            nombre: nameExpense
        }
        let errors = validateForm(dataSend);
        setErrors(errors);

        if (Object.entries(errors).length === 0) {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'gastos-tipo/update', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then((response) => {
                    if (response.status != 500 && response.status != 403) {
                        setEditTypeExpense(false);
                        return response.text();
                    }
                    else {
                        throw new Error("Un Error ha ocurrido en el servidor");
                    }
                })
                .then((data) => {
                    console.log(data)
                    getTypesExpenses();
                    setNameExpense('')
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    };

    const LoadInfo = () => {
        return (<DataReactTableTypesExpenses
            reactTableData={reactTableDataTypesExpenses}
            refresh={getTypesExpenses}
            update={updateTypeExpense}
            setEditTypeExpense={setEditTypeExpense}
            setNameExpense={setNameExpense}
            setIdTypeExpense={setIdTypeExpense}
        />)
    }

    return (
        <Fragment>
            <div className='card-type-expenses'>
                <Row>
                    <Col>
                        <div className='title'>
                            <h4><b>FORMULARIO TIPOS DE GASTOS</b></h4>
                        </div>
                        <div className='card-type-expenses-form'>
                            <div>
                                <TextField
                                    label="Nombre del Gasto"
                                    value={nameExpense}
                                    onChange={(event) => {
                                        setNameExpense(event.target.value)
                                    }}
                                    type="text"
                                    className="medical-material-form__field"
                                    /* InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink: cost == "" || cost == null || cost == undefined ? false : true
                                    }} */
                                    error={errors.hasOwnProperty("nombre") ? errors.nombre !== "" : false}
                                    helperText={errors.nombre}
                                />
                            </div>
                            <div>
                                <Button
                                    size="sm"
                                    color="primary"
                                    onClick={() => {
                                        if (editTypeExpense == true && idTypeExpense !== '') {
                                            updateTypeExpense(idTypeExpense);
                                        } else {
                                            saveTypeExpense();
                                        }
                                    }}
                                >
                                    {editTypeExpense ? "Editar" : "Guardar"}
                                </Button>
                            </div>
                        </div>
                        {
                            loadTable ?
                                <div className="text-center">
                                    <Spinner animation="border" style={{ color: '#4ce1b6' }} />
                                </div>
                                :
                                <LoadInfo />
                        }
                    </Col>
                </Row >

                {
                    openAlert ?
                        <ModalUI
                            color={modalAlert.color
                            }
                            title={modalAlert.title}
                            message={modalAlert.message}
                            modal={openAlert}
                            toggle={() => { setOpenAlert(!openAlert) }}
                            onOk={() => { setOpenAlert(!openAlert) }}
                        /> : null}
            </div >
        </Fragment >
    )
}

export default TypeExpensesForm